import React, { type ForwardedRef, forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFelaEnhanced } from '@ackee/fela';

import { useLocation } from '@reach/router';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import * as UI from '../../ui';
import { content, InquiryType } from './content';

import InquirySectionWithImage from './InquirySectionWithImage';
import * as felaRules from './InquirySection.rules';

const { DynamicContainer, ContainerType, Title, TitleTypes, LocalizedLink } = UI;

interface InquirySectionProps {
    type?: InquiryType;
}

export const InquirySection = forwardRef(
    ({ type = InquiryType.BASIC }: InquirySectionProps, ref: ForwardedRef<HTMLElement>) => {
        const { styles, rules } = useFelaEnhanced(felaRules);
        const { pathname } = useLocation();
        return (
            <>
                {type === InquiryType.WITH_IMAGE ? (
                    // @ts-expect-error
                    <InquirySectionWithImage reference={ref} />
                ) : (
                    <DynamicContainer
                        ref={ref}
                        extend={{ container: rules.extendContainer }}
                        isFluid
                        as={ContainerType.SECTION}
                    >
                        {/* @ts-expect-error */}
                        <Title as={TitleTypes.H3} type={TitleTypes.H1_ITALIC} extend={{ title: rules.extendTitle }}>
                            <FormattedMessage id={content[type].title} />
                        </Title>
                        <LocalizedLink
                            eventId="contact-bottom"
                            className={getPlausibleClassName(styles.link, AnalyticsEvent.CONTACT_BOTTOM_CLICK, {
                                origin_path: pathname,
                            })}
                            to={content[type].link}
                        >
                            {/* @ts-expect-error */}
                            <Title
                                size={TitleTypes.H1_LINK_ITALIC}
                                type={TitleTypes.H1_LINK_ITALIC}
                                as={TitleTypes.H4}
                                extend={{ title: rules.extendLinkTitle }}
                            >
                                <FormattedMessage id={content[type].cta} />
                            </Title>
                        </LocalizedLink>
                    </DynamicContainer>
                )}
            </>
        );
    },
);
